<mat-form-field class="flex w-full">
  <mat-label>Mēnesis</mat-label>
  <mat-date-range-input [rangePicker]="monthPicker">
    <input matStartDate placeholder="Sākuma datums" readonly [value]="selectedStartDate" />
    <input matEndDate placeholder="Beigu datums" readonly [value]="selectedEndDate" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="monthPicker" />
  <mat-datepicker-toggle matSuffix aria-label="Notīrīt filtru" (click)="clearDate()">
    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
  </mat-datepicker-toggle>
  <mat-date-range-picker #monthPicker panelClass="month-datepicker" startView="year" (monthSelected)="onMonthSelected($event, monthPicker)" />
</mat-form-field>
